import * as React from 'react';

type Props = {
  className?: string;
};

export const IconEvent: React.FC<Props> = ({ className = undefined }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 48 48" className={className}>
    <path d="M24 25.15ZM11.65 44 16.3 28.8 4 20H19.2L24 4L28.8 20H44L31.7 28.8L36.35 44L24 34.6ZM17.15 35.85 24 30.65 30.85 35.85 28.1 27.2 34.4 23.1H26.85L24 14.45L21.15 23.1H13.6L19.9 27.2Z" />
  </svg>
);
